export default {
  title: '有效订单',
  body: {
    cmpt: {
      type: 'CValidSettleOrderList'
    }
  }
}
